<ng-container *ngIf="hasValidLocation">
  <agm-map class="w-100" [latitude]="latitude" [longitude]="longitude" [zoom]="12">
    <agm-marker [markerClickable]="false" [latitude]="latitude" [longitude]="longitude" [label]="labelOptions"
      [title]="location?.locality || location?.adminLevel2 || location?.adminLevel1" [markerDraggable]="true"
      (dragEnd)="selectPosition($event)">
    </agm-marker>
  </agm-map>
</ng-container>